import { useTranslation } from 'react-i18next'
import type { Locale } from './i18n'

export { type Locale } from './i18n'

export function useI18n() {
  const { t, i18n } = useTranslation()
  return {
    t: t as (key: string, params?: Record<string, string | number>) => string,
    locale: i18n.language as Locale,
    setLocale: (locale: Locale) => {
      i18n.changeLanguage(locale)
    },
  }
}
